import { calculaValoresFrete } from '@sotran/lib-shipper';

import { getDadosCalculoFrete } from '../../../../helpers/calculaValoresLote';
import { removeMoedaMask } from '../../../../helpers/formatador';
import { getIdCidades } from './cidades';
import { validarCidadeOrigemDestino } from './validators';

export const getDadosCalculo = async record => {
  const dadosEndereco = getIdCidades(record);
  if (validarCidadeOrigemDestino(record.dadosEndereco, dadosEndereco)) {
    return record;
  }
  const {
    tarifaTmovCliente,
    isPercentualTmov,
    pedagioCalculado,
  } = await getDadosCalculoFrete(dadosEndereco, record.idClienteRaiz);

  record.tarifaTmov = tarifaTmovCliente;
  record.isPercentualTmov = isPercentualTmov;
  record.pedagio = Number(pedagioCalculado.toFixed(2));
  record.icms = 0;
  record.dadosEndereco = dadosEndereco;

  return record;
};

export const calculaFretes = async (value, tipoFrete, record) => {
  const valor = removeMoedaMask(
    value || record.freteMotoristaPj || record.freteTotalPj
  );
  let { tarifaTmov } = record;
  const { icms, pedagioIncluso } = record;
  let { pedagio } = record;
  pedagio = pedagioIncluso === 'SIM' ? 0 : pedagio;

  if (!tarifaTmov.tipoTarifa) {
    tarifaTmov = {
      tipoTarifa: 'REAIS',
      tarifas: [
        {
          valor_inicial: 0,
          valor_final: 9999999,
          valor_tarifa_percentual: 0,
          valor_tarifa_reais_tonelada: 0,
        },
      ],
    };
  }

  if (tipoFrete.includes('freteMotorista')) {
    record.freteInserido = 'freteMotorista';
  } else {
    record.freteInserido = 'freteTotal';
  }

  const isPercentualTarifaTmov = tarifaTmov.tipoTarifa === 'PERCENTUAL';
  const valorTarifaTmov = tarifaTmov.tarifas
    .filter(faixa => valor >= faixa.valor_inicial && valor <= faixa.valor_final)
    .pop();

  const valorTarifa = isPercentualTarifaTmov
    ? valorTarifaTmov.valor_tarifa_percentual / 100 || 0
    : valorTarifaTmov.valor_tarifa_reais_tonelada || 0;

  const freteCalculado = calculaValoresFrete(
    valor,
    record.freteInserido,
    valorTarifa,
    isPercentualTarifaTmov,
    icms,
    pedagio
  );

  if (tipoFrete === 'freteMotorista') {
    const fretePj = calculaValoresFrete(
      removeMoedaMask(record.freteMotoristaPj || 0),
      tipoFrete,
      valorTarifa,
      isPercentualTarifaTmov,
      icms,
      pedagio
    );
    const fretePf = calculaValoresFrete(
      removeMoedaMask(record.freteMotoristaPf || 0),
      tipoFrete,
      valorTarifa,
      isPercentualTarifaTmov,
      icms,
      pedagio
    );

    record.freteTotalPj = fretePj;
    record.freteTotalPf = fretePf;
  } else if (tipoFrete === 'freteTotal') {
    const fretePj = calculaValoresFrete(
      removeMoedaMask(record.freteTotalPj || 0),
      tipoFrete,
      valorTarifa,
      isPercentualTarifaTmov,
      icms,
      pedagio
    );
    const fretePf = calculaValoresFrete(
      removeMoedaMask(record.freteTotalPf || 0),
      tipoFrete,
      valorTarifa,
      isPercentualTarifaTmov,
      icms,
      pedagio
    );

    record.freteMotoristaPj = fretePj;
    record.freteMotoristaPf = fretePf;
  } else if (tipoFrete === 'freteMotoristaPj') {
    record.freteTotalPj = freteCalculado;
  } else if (tipoFrete === 'freteTotalPj') {
    record.freteMotoristaPj = freteCalculado;
  } else if (tipoFrete === 'freteMotoristaPf') {
    record.freteTotalPf = freteCalculado;
  } else if (tipoFrete === 'freteTotalPf') {
    record.freteMotoristaPf = freteCalculado;
  }

  return record;
};

export const calculaFreteInicial = async lotesIntegracao => {
  const resultadoLotesIntegracao = lotesIntegracao.map(loteRes => {
    const { freteInserido } = loteRes;

    if (!freteInserido) return loteRes;

    const valor = loteRes[freteInserido];

    if (loteRes.errors.frete) {
      delete loteRes.errors.frete;
    }

    return calculaFretes(valor, freteInserido, loteRes);
  });

  return Promise.all(resultadoLotesIntegracao);
};
